import React, { createElement, useEffect, useState } from 'react';
import { Cascader, Form, Col } from 'antd';
import { generateRules } from '../../../utils';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { getDeptTree } from "../../../api/form";
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const FormCascaderSingle = (props, ref) => {
    const { isNecessary, verifytext, title, __id, rules, status, span, column, options, dynamicOptions, ...other } = props;
    const displayRender = (labels) => labels[labels.length - 1];
    const [rule, setRule] = useState([]);
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [ops, setOps] = useState([]);
    useEffect(() => {
        setError(false);
        try {
            if (props?.dynamic) {
                if (dynamicOptions === '组织树') {
                    getDeptTree().then(res => {
                        setOps(res.data);
                    });
                }
            }
            else {
                setOps(options);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('选项初始化失败，请检查配置');
        }
    }, []);
    useEffect(() => {
        try {
            setRule(generateRules(rules));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '级联单选', name: __id || props.componentId, rules: rule },
                createElement(Cascader, Object.assign({ disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other, { displayRender: displayRender, expandTrigger: "hover", options: ops }))))))));
};
export default React.forwardRef(FormCascaderSingle);
